// src/blocks/embed-button/vivenu-context.ts
var _context = {};
var setVivenuContext = (ctx) => {
  _context = ctx;
};
var getVivenuContext = () => _context;

export {
  setVivenuContext,
  getVivenuContext
};
